import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import { isNullOrUndefined } from '../../../store/storeFunctions';
import Money from "../../common/moneyComponent";

class Summary extends React.Component {
    static defaultProps = {
        isITradeContributor: false,
        isITradeUnlimited: false
    };

    render() {
        const { data, extended, enhancements, isITradeContributor, isITradeUnlimited } = this.props;
        const tableData = this.getTableData(data, extended, enhancements, isITradeContributor, isITradeUnlimited);
        return (
            <>
                <span className='underlined-title-wrapper'><span className='underlined-title'><Translate id="Report.Itrade.PaymentData" /></span></span>
                <br />
                <table className="table old-style-table-report-2 old-style-left-offset fixed key-value">
                    <tbody>
                        {tableData.map((t, i) => <tr key={i}>
                            <td style={{ width: "50%", fontWeight: "bold" }}>{t.key}</td>
                            <td style={{ width: "50%"}}>{t.value}</td>
                        </tr>)}
                    </tbody>
                </table>
            </>
        );
    }

    getTableData = (data, extended, enhancements, isContributor, isUnlimited) => {
        const tr = (k, c) => isNullOrUndefined(c) ? this.props.translate(k) : this.props.translate(k, { currency: c });
        const unlimited = isContributor && isUnlimited && enhancements;
        const result = [];

        this.addData(!isNullOrUndefined(data.total), result, tr("Report.Itrade.TotalValue", data.currency), data.totalFormatted);
        this.addData(!isNullOrUndefined(data.avg), result, tr("Report.Itrade.AvgExperienceValue", data.currency), data.avgFormatted);
        this.addData(!isNullOrUndefined(data.exp), result, tr("Report.Itrade.ExperienceCount"), data.expFormatted);
        this.addData(isContributor, result, tr("Report.Itrade.InvoicingPaid", data.currency),
            (!isNullOrUndefined(data.total) && !isNullOrUndefined(extended.amountOpen) && extended.amountOpen !== 0
                ? <Money value={data.total - extended.amountOpen} fractionDigits={0}></Money>
                : <>{data.totalFormatted || "0"}</>));
        this.addData(isContributor, result, tr("Report.Itrade.TotalOwing", data.currency),
            extended.amountOpenFormatted || "0");
        this.addData(isContributor && !isNullOrUndefined(extended.performance), result, tr("Report.Itrade.AvgPerformance"), extended.performanceFormatted);
        this.addData(unlimited, result, tr("Report.Itrade.TotalOwingGroup", data.currency),
            <Money value={this.calculateTotal(enhancements, false)} fractionDigits={0}></Money>);
        this.addData(unlimited, result, tr("Report.Itrade.TotalOwingCustomer", data.currency),
            <Money value={this.calculateTotal(enhancements, true)} fractionDigits={0}></Money>);

        return result;
    }

    addData = (condition, array, key, value) => {
        if (condition)
            array.push({ key: key, value: value });
    }

    calculateTotal = (enhancements, contributor) => {
        const array = enhancements.filter(x => !x.isHistorical && x.isContributor === contributor);
        return array.length === 0 ? 0 : array.map(x => x.openTotal).reduce((a, b) => a + b);
    }
}

export default withLocalize(Summary)